import NameIcon from '@mui/icons-material/AccountBoxOutlined';
import EmailIcon from '@mui/icons-material/AlternateEmailOutlined';
import DropdownIcon from '@mui/icons-material/ArrowDropDownCircleOutlined';
import DateIcon from '@mui/icons-material/DateRange';
import AddMemberIcon from '@mui/icons-material/FamilyRestroomOutlined';
import NumberIcon from '@mui/icons-material/Filter1Outlined';
import ParagraphIcon from '@mui/icons-material/FormatAlignLeftOutlined';
import ScheduleIcon from '@mui/icons-material/InsertInvitationOutlined';
import ChoiceIcon from '@mui/icons-material/LibraryAddCheckOutlined';
import AddressIcon from '@mui/icons-material/LocationOnOutlined';
import PhoneIcon from '@mui/icons-material/PhoneAndroidOutlined';
import BooleanIcon from '@mui/icons-material/RadioButtonUnchecked';
import SurveyIcon from '@mui/icons-material/SentimentVerySatisfied';
import ShortTextIcon from '@mui/icons-material/ShortText';
import RatingIcon from '@mui/icons-material/StarOutline';

export default {
  NAME: 'name',
  EMAIL: 'email',
  PHONE: 'phone',
  SCHEDULER: 'scheduler',
  ADD_MEMBERS: 'add_member',
  TEXT: 'text',
  PARAGRAPH: 'paragraph',
  ADDRESS: 'address',
  CHOICE: 'choice',
  BOOLEAN: 'boolean',
  DATE: 'date',
  NUMBER: 'number',
  SURVEY: 'survey',
  RATING: 'rating',
};

export const FIELD_LABELS = {
  boolean: 'Yes / No',
  date: 'Date',
  dropdown: 'Dropdown',
  choice: 'Multiple Choice',
  text: 'Short Text',
  paragraph: 'Long Text',
  number: 'Number',
  email: 'Email',
  phone: 'Phone Number',
  name: 'Full Name',
  scheduler: 'Plan a Visit',
  add_member: 'Pre-Register Kids',
  address: 'Address',
  survey: '1-10 Survey',
  rating: '5 Star Rating',
};

export const FIELD_DESCRIPTION = {
  name: 'This asks for the person’s first and last name.',
  email: 'This asks for the person’s email address.',
  phone: 'This asks for the person’s mobile number.',
  scheduler:
    'This asks what date and time a person would like to visit your church.',
  add_member:
    'This asks allows the person to add their children, their birthdate and if they have any special requirements.',
  text: 'This adds a short text box to your card. This is great for one to three word answers.',
  paragraph:
    'This adds a larger text box to your card. This is great to use when someone needs to write a full sentence.',
  address: 'This asks for the person’s full mailing address.',
  choice:
    'This asks a multiple choice question that can be single select or multi-select.',
  boolean: 'This asks the person to respond with yes or no to your question.',
  date: 'This asks for a date input. This is great when needing to collect birthday’s or anniversaries.',
  number:
    'This asks for a number input. This is helpful when needing a quantity of something.',
  survey: 'This asks the person to rate something from 1-10.',
  rating: 'This asks the person to rate something from 1 star to 5 star.',
};

export const COLORS = {
  boolean: {
    background: '#F8D3BE',
    color: '#ca2626',
  },
  date: {
    background: '#E6FAF7',
    color: '#4597A1',
  },
  dropdown: {
    background: '#FAE28E',
    color: '#A75428',
  },
  choice: {
    background: '#E9F6FE',
    color: '#1A70CF',
  },
  number: {
    background: '#E8F3C3',
    color: '#5B7217',
  },
  text: {
    background: '#E4E7EB',
    color: '#FFB800',
  },
  paragraph: {
    background: '#E4E7EB',
    color: '#FF7A00',
  },
  email: {
    background: '#cfe7ec',
    color: '#3A7685',
  },
  phone: {
    background: '#eff6f0',
    color: '#4F71E8',
  },
  name: {
    background: '#eff6f0',
    color: '#894FE8',
  },
  scheduler: {
    background: '#eff6f0',
    color: '#4F71E8',
  },
  add_member: {
    background: '#eff6f0',
    color: '#94C843',
  },
  address: {
    background: '#eff6f0',
    color: '#FC5959',
  },
  survey: {
    background: '#eff6f0',
    color: '#FF7A00',
  },
  rating: {
    background: '#eff6f0',
    color: '#FF7A00',
  },
};

export const FIELD_ICONS = {
  boolean: BooleanIcon,
  date: DateIcon,
  dropdown: DropdownIcon,
  choice: ChoiceIcon,
  number: NumberIcon,
  text: ShortTextIcon,
  paragraph: ParagraphIcon,
  phone: PhoneIcon,
  email: EmailIcon,
  name: NameIcon,
  address: AddressIcon,
  scheduler: ScheduleIcon,
  add_member: AddMemberIcon,
  survey: SurveyIcon,
  rating: RatingIcon,
};
